'use client'
import React from 'react'

import { ListHeader } from '../../molecules/ListHeader/ListHeader'
import { TimelineFilterWrapper } from './TimelineFilterWrapper'

interface TimelineTopControlsProps extends React.HTMLAttributes<HTMLDivElement> {
    /** Title displayed above the timeline */
    title: string
    /** List of <ContextMenuSelectFilter> shown in a context menu */
    contextFilters?: React.ReactElement
    /** <TimelineSwitcherFilter> */
    switcherFilter?: React.ReactElement
}

export const TimelineTopControls = ({
    title,
    contextFilters,
    switcherFilter,
}: TimelineTopControlsProps): JSX.Element => {
    return (
        <ListHeader
            title={title}
            bottomContent={switcherFilter}
            actions={<TimelineFilterWrapper>{contextFilters}</TimelineFilterWrapper>}
        />
    )
}
